import { reactive } from 'vue';
import i18n from '../../../../i18n';
import { createLoading } from '../../../../utils/loading';
import {
    createManageExportCsv,
    createManageSelect,
    createPage
} from '../../../../utils/page';
import {
    createColumnInput,
    createColumnInputNumber,
    createColumnSelect
} from '../../../../components/table/c-table.logic';
import store from '../../../../store';
import lodash from "lodash"
import { getLabTopicByLabTypeKey } from '../../master-mgt/lab/lab-share.logic';
import { callAquaticType, callProductConsumption, callProductType } from '../../master-mgt/product/product.logic';
import { callCountry } from '../../master-mgt/country/country.logic';
import { callLabTopic } from '../../master-mgt/lab/sampling-monitor-type-lab-topic/sampling-monitor-type-lab-topic.logic';

export const callSearchSamplingProductAnalysis = ({ criteria }) => store.dispatch(`resource/v1/transaction/samplingProductAnalysis/search`, { criteria });
export const callSearchProduct = ({ criteria }) => store.dispatch(`resource/v1/master/product/search`, { criteria });

const callDepartment = ({ searchQuery, refLabTypeKey }) =>
    store.dispatch("resource/v1/master/department/cacheFindAll", {
        searchQuery,
        where: [
            { name: "refDepartmentType.key", type: "String", operator: "=", value: "LAB" },
            { name: "refLabType.key", type: "String", operator: "=", value: refLabTypeKey }
        ]
    });


const callLabExt = ({ searchQuery, isLabExtKey }) =>
    store.dispatch("resource/v1/master/labExt/cacheFindAll", {
        searchQuery,
        where: [{ name: `${isLabExtKey}`, type: "Boolean", operator: "=", value: true }]
    });


export const { isLoading, setIsLoading } = createLoading();

export const onSearch = ({ page, props, isSet = true }) => {

    setIsLoading(true);

    const { where = [] } = page;
    const sort = page.sort || [];
    window.onSearch?.({ page });
    const customWhere = lodash.cloneDeep(where);
    const children = [{
        select: ['*',
            'refLabTopic.id',
            'refLabTopic.name',
            'refLabTopic.nameS'
        ],
        name: 'topics',
        page: 0,
        size: 1000,
        children: [{
            select: ['id'],
            name: 'transferTos',
            page: 0,
            size: 1000
        }],
        where: []
    }]

    const countryIndex = customWhere.findIndex(d => d.name?.startsWith("refSamplingProductAnalysis.refSamplingProduct.refCountry1"));
    if (countryIndex !== -1) {
        const countryWhere = customWhere[countryIndex];
        customWhere.splice(
            countryIndex,
            1,
            {
                openBucket: true,
                name: "refSamplingProduct.refCountry1.id",
                type: "UUID",
                operator: "=",
                value: countryWhere.value
            },
            {
                logic: "OR",
                closeBucket: true,
                name: "refSamplingProduct.refCountry2.id",
                type: "UUID",
                operator: "=",
                value: countryWhere.value
            }
        );
    }

    const topicIndex = customWhere.findIndex(d => d.name?.startsWith("refLabTopic.id"));

    if (topicIndex !== -1) {
        const whereTopic = lodash.cloneDeep(customWhere[topicIndex]);
        customWhere.splice(topicIndex, 1);
        children.find(it => it.name == 'topics').where.push({ ...whereTopic })
    }

    const departmentIndex = customWhere.findIndex(d => d.name?.startsWith("refDepartment"));
    if (departmentIndex !== -1) {
        const departmentWhere = customWhere[departmentIndex];
        customWhere.splice(
            departmentIndex,
            1,
            {
                openBucket: true,
                name: "refDepartment.id",
                type: "UUID",
                operator: "=",
                value: departmentWhere.value
            },
            {
                logic: "OR",
                closeBucket: true,
                name: "refLabExt.id",
                type: "UUID",
                operator: "=",
                value: departmentWhere.value
            }
        );
    }

    return callSearchSamplingProductAnalysis({
        criteria: {
            ...page,
            where: [
                ...customWhere,
                { name: 'refLabType.key', type: 'String', operator: '=', value: props.refLabTypeKey, },
                { name: 'refSamplingProduct.refSamplingRequest.refSamplingRequestType.key', type: 'String', operator: 'in', value: ['L', 'S'] }
            ],
            children,
            data: []
        }
    }).then(page => {
            const reportDatas = reactive([])
            page.data.forEach(analysis => {

                const refDepartment = analysis.refDepartment ? analysis.refDepartment : analysis.refLabExt
                analysis.refDepartment = refDepartment;
                analysis.topics = analysis.topics.filter(topic => topic.transferTos.length  == 0);
                const labDeptId = analysis.refDepartment?.id ? analysis.refDepartment?.id : analysis.refLabExt?.id
                const companyId = analysis.refSamplingProduct?.refSamplingRequest?.refCompany?.id
                const productId = analysis.refSamplingProduct?.refCompanyProduct?.refProduct?.id
                const countries = [analysis?.refSamplingProduct?.refCountry1]
                if (analysis?.refSamplingProduct?.refCountry2) {
                    countries.push(analysis?.refSamplingProduct?.refCountry2)
                }
                lodash.sortBy(countries, "seq")
                const countryJoinId = countries.map(it => it.id).join('')
                const countryJoinName = countries.map(it => it.nameTh).join(',')
                lodash.set(analysis, "nameCountries",  countryJoinName);
                const combineGroupId = labDeptId + companyId + productId + countryJoinId
                analysis.combineGroupId = combineGroupId;
                const index = reportDatas.findIndex(it => it.combineGroupId == analysis.combineGroupId)
                if (index > -1) {
                    analysis.topics?.forEach(analysisTopic => {
                        if (!lodash.get(reportDatas[index], analysisTopic.refLabTopic.id)) {
                            analysisTopic.refLabTopic.count = 1;
                            lodash.set(reportDatas[index], analysisTopic.refLabTopic.id,  analysisTopic.refLabTopic);
                        } else {
                            lodash.get(reportDatas[index],  analysisTopic.refLabTopic.id).count += 1
                        }
                    })
                } else {
                    analysis.topics.forEach(analysisTopic => {
                        lodash.set(analysisTopic.refLabTopic, "count", 1)
                        lodash.set(analysis, analysisTopic.refLabTopic.id, analysisTopic.refLabTopic)
                    })
                    reportDatas.push(analysis)
                }
            })
            //state.page = { ...page, where, sort }
            //state.page.size = 10000000

            // state.page = { data: [...reportDatas],
            //     page: 0,
            //     size: 1000,
            // };
            return isSet ? (state.page = { ...page, where, sort }) : page;
        }).finally(() => setIsLoading(false));
};


export const createColumns = ({ props }) => {
    const { refLabTypeKey } = props;
    if (state.columns.length == 0) {
        getLabTopicByLabTypeKey({ labTypeKey: props.refLabTypeKey }).then(topics => {
            state.columns.push(createColumnSelect({
                visible: () => false,
                title: () => i18n.global.t("views.report.labMicro.exportProductTopicReport.labTopic"),
                inputProp: () => ({
                    list: ({ searchQuery }) => callLabTopic({ searchQuery, labTypeKey: props.refLabTypeKey }),
                    optLabel: "name",
                    mode: "multiple"
                }),
                search: {
                    visible: () => true,
                    name: "refLabTopic.id",
                    operator: "in",
                    getValue: ({ value }) => value.map(d => d.id),
                    field: { searchValue: [] }
                }
            })),
            state.columns.push(createColumnSelect({
                title: () => i18n.global.t("views.report.labMicro.exportProductTopicReport.department"),
                dataIndex: "refDepartment.nameTh",
                customRender: ({ record }) => {
                    return <div>{record?.refDepartment?.nameTh || record?.refLabExt?.nameTh}</div>
                },
                inputProp: () => ({
                    list: ({ searchQuery }) =>
                        Promise.all([callDepartment({ searchQuery, refLabTypeKey }), callLabExt({ searchQuery, isLabExtKey: lodash.clone(props?.refLabTypeKey).replace("lab", "is") })]).then(arr => [...arr[0], ...arr[1]]),
                    optLabel: "nameTh"
                }),
                search: { name: "refDepartment.id" },
                fixed: 'left',
            })),
            state.columns.push(createColumnSelect({
                title: () => i18n.global.t('views.report.labMicro.exportProductTopicReport.company'),
                dataIndex: 'refSamplingProduct.refSamplingRequest.refCompany.nameTh',
                align: 'center',
                inputProp: () => {
                    return {
                        list: ({ searchQuery }) => {
                            const where = [
                                { name: "isActive", type: "Boolean", operator: "=", value: true },
                                { name: "isTmp", type: "Boolean", operator: "=", value: false },
                            ]
                            if (searchQuery) {
                                where.push({ name: "nameTh", type: "String", operator: "like", value: searchQuery });
                                where.push({ name: "nameEn", type: "String", operator: "like", value: searchQuery });
                            }
                            return store.dispatch("resource/v1/transaction/company/search", { criteria: { select: ["**"], page: 0, size: 1000000, where: [...where] } }).then(page => page.data)
                        },
                        renderLabel: ({ item }) => <div>{item?.nameTh}</div>,
                    };
                },
                fixed: 'left',
                search: {
                    name: 'refSamplingProduct.refSamplingRequest.refCompany.id',
                }
            })),
            state.columns.push(createColumnSelect({
                title: () => i18n.global.t('model.product.refProductType'),
                dataIndex: 'refSamplingProduct.refCompanyProduct.refProduct.refProductType.value',
                inputProp: () => ({
                    list: callProductType,
                    renderLabel: ({ item }) => (
                        <div>
                            {item.value}
                        </div>
                    )
                }),
                search: {
                    name: 'refSamplingProduct.refCompanyProduct.refProduct.refProductType.id'
                },
                align: 'center',
                fixed: 'left'
            })),
            state.columns.push(createColumnSelect({
                title: () => i18n.global.t('model.product.refAquaticType'),
                dataIndex: 'refSamplingProduct.refCompanyProduct.refProduct.refAquaticType.value',
                inputProp: ({ field }) => {
                    const aquaticSpeciesField = field?.columns?.find(d => d.dataIndex === 'refAquaticSpecies.value')?.search?.field;
                    return {
                        list: callAquaticType,
                        renderLabel: ({ item }) => (
                            <div>
                                {item.value}
                            </div>
                        ),
                        'onUpdate:value': value => {
                            field.searchValue = value;
                            if (aquaticSpeciesField) {
                                aquaticSpeciesField.searchValue = null;
                            }
                        }
                    };
                },
                search: {
                    name: 'refSamplingProduct.refCompanyProduct.refProduct.refAquaticType.id'
                },
                align: 'center',
                fixed: 'left'
            })),
            state.columns.push(createColumnSelect({
                title: () => i18n.global.t('model.product.refProductConsumption'),
                dataIndex: 'refSamplingProduct.refCompanyProduct.refProduct.refProductConsumption.value',
                inputProp: () => ({
                    list: callProductConsumption,
                    renderLabel: ({ item }) => (
                        <div>
                            {item?.value}
                        </div>
                    )
                }),
                search: {
                    name: 'refSamplingProduct.refCompanyProduct.refProduct.refProductConsumption.id'
                },
                align: 'center',
                fixed: 'left'
            }));
            state.columns.push(createColumnSelect({
                title: () => i18n.global.t('views.report.labMicro.exportProductTopicReport.productName'),
                dataIndex: 'refSamplingProduct.refCompanyProduct.refProduct.nameTh',
                inputProp: () => ({
                    list: ({ searchQuery }) => {
                        const criteria = {
                            select: ["**"],
                            page: 0,
                            size: 1000000,
                            where: []
                        };
                        if (searchQuery) {
                            criteria.where.push( { name: 'nameTh', type: 'String', operator: 'like', value: searchQuery },
                            { name: 'nameEn', type: 'String', operator: 'like', value: searchQuery },
                            { name: 'code', type: 'String', operator: 'like', value: searchQuery })
                        }
                        return callSearchProduct({ criteria }).then(res => res.data);
                    },
                    renderLabel: ({ item }) => (<div> {item?.nameTh} </div>)
                }),
                search: {
                    name: 'refSamplingProduct.refCompanyProduct.refProduct.id'
                },
                align: 'center',
                fixed: 'left'
            })),
            state.columns.push(
                createColumnInput({
                    visible: () => false,
                    title: () => i18n.global.t('views.report.labMicro.exportProductTopicReport.countries'),
                    dataIndex: `nameCountries`,
                    align: 'center',
                    search: { visible: () => false },
                    width: 100,
                    fixed: 'left'
            })),
            state.columns.push(
                createColumnSelect({
                    title: () => i18n.global.t("views.report.labMicro.exportProductTopicReport.countries"),
                    dataIndex: "refSamplingProductAnalysis.refSamplingProduct.refCountry1.nameTh",
                    customRender: ({ record }) => {
                        if (!record?.refSamplingProduct?.refCountry2) {
                            return <div>
                                {record?.refSamplingProduct?.refCountry1?.nameTh}
                            </div>
                        }
                        else if (record?.refSamplingProduct?.refCountry1?.seq < record?.refSamplingProduct?.refCountry2?.seq) {
                            return <div>
                                {record?.refSamplingProduct?.refCountry1?.nameTh}{","}
                                {record?.refSamplingProduct?.refCountry2?.nameTh}
                            </div>
                        } else  {
                            return <div>
                                {record?.refSamplingProduct?.refCountry2?.nameTh}{","}
                                {record?.refSamplingProduct?.refCountry1?.nameTh}
                            </div>
                        }
                    },
                    inputProp: () => ({ list: callCountry, optLabel: "nameTh" }),
                    search: { name: "refSamplingProductAnalysis.refSamplingProduct.refCountry1.id" },
                    align: "center",
                    fixed: "left"
                }),
            )
            topics.forEach(topic => {
                state.columns.push(createColumnInputNumber({
                    title: () => topic.nameS,
                    dataIndex: `${topic.id}.count`,
                    align: 'center',
                    search: { visible: () => false },
                    width: 100,
                    sorter: false
                }))
            })
        });
    }
};

export const state = reactive({
    columns: [],
    page: createPage({
        options: {
            select: [
                '**',
                'refCreateBy.fullName',
                "refSamplingProduct.refCountry1.*",
                "refSamplingProduct.refCountry2.*",
                'refSamplingProduct.refSamplingRequest.refCompany.*',
                'refSamplingProduct.refCompanyProduct.refProduct.**',
                'refSamplingProduct.refSamplingRequest.refCompany.**'
            ],

            page: 0,
            size: 20
        }
    }),
    tableOptions: { search: { activeKey: 'Search' } }
});

export const initState = ({ props, data }) => {
    const menuContext = props.menuContext;
    createColumns({ props, data });
    state.manages = [
        createManageSelect({ menuContext }),
        createManageExportCsv({ 
            menuContext,
            callData: ({ page }) => onSearch({ props, page: { ...lodash.cloneDeep({ ...page, props, page: 0, size: 1000000 }) }, isSet: false })
        })
    ];
    state.manageExtras = [];
};


